import { render, staticRenderFns } from "./InstructionForm.vue?vue&type=template&id=1e5ba286&scoped=true"
import script from "./InstructionForm.vue?vue&type=script&lang=js"
export * from "./InstructionForm.vue?vue&type=script&lang=js"
import style0 from "./InstructionForm.vue?vue&type=style&index=0&id=1e5ba286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5ba286",
  null
  
)

export default component.exports